import React, { useState } from "react";
import { isObject } from "../../services/Helpers/ObjectHelper";

const RetailFooter = () => {
  const [multipliersHistory, setMultiplierHistory] = useState([]);
  window.setRetailMultipliersHistory = setMultiplierHistory;

  let highLight = (mp) => {
      if (Number(mp) > 0.99 && Number(mp) <= 1.99) return "light-blue";
      if (Number(mp) > 1.99 && Number(mp) <= 4.99) return "blue";
      if (Number(mp) > 4.99 && Number(mp) <= 9.99) return "green";
      if (Number(mp) > 9.99 && Number(mp) <= 49.99) return "yellow";
      if (Number(mp) > 49.99 && Number(mp) <= 99.99) return "orange";
      if (Number(mp) > 99.99) return "red";

      return "win-small";
    };

  return (
    <div
      className={
        "play-now-footer play-now-footer-retail"
      }
    >
      <div className="container">
        <div className="play-now-footer-mmsb-holder">
          {multipliersHistory
            .slice(0)
            .reverse()
             .map((val, index) => {
                if (isObject(val)) {
                  return (
                    <p
                      className={[
                        "mmsb-info-content",
                        highLight(val?.mt),
                        val?.bonus ? "mmsb-info-bonus" : "",
                      ].join(" ")}
                      key={index}
                    >
                      {val?.mt ? val.mt.toFixed(2) : ""}x
                    </p>
                  );
                } else {
                  return (
                    <p
                      className={["mmsb-info-content", highLight(val)].join(" ")}
                      key={index}
                    >
                      {val ? val.toFixed(2) : ""}x
                    </p>
                  );
                }
                
              })}
        </div>
      </div>
    </div>
  );
};

export default RetailFooter;
